<template>
  <Modal
    ref="modal"
    :title="`Edit ${field.schema && field.schema.title}`"
  >
    <BaseForm
      submit-title="Submit"
      @submit="save"
      @cancel="cancel"
    >
      <SchemaPropertyField
        v-model="value"
        :name="field.name"
        :schema="field.schema"
        :required="field.required"
      />
      <FieldError v-model="error" />
    </BaseForm>
  </Modal>
</template>

<script>
/**
 * Modal to change the Sites assigned to a Project.
 */
import Modal from '@/components/Modal'
import SchemaPropertyField from '@/components/SchemaPropertyField'
import FieldError from '@/components/FieldError'
import projectAPI from '@/api/project'

export default {
  components: {
    Modal,
    SchemaPropertyField,
    FieldError,
  },
  props: {
    project: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      error: '',
      field: {
        name: '',
        required: false,
        schema: { title: '' },
      },
      value: '',
    }
  },
  methods: {
    reset () {
      this.error = ''
    },
    cancel () {
      this.$refs.modal.hide()
      this.reset()
    },
    edit (field) {
      this.reset()
      this.field = field
      this.value = this.project.p4p[this.field.name]
      this.$refs.modal.show()
    },
    save () {
      projectAPI.updateP4PProp(this.project.id, this.field.name, this.value).then(resp => {
        this.$emit('prop-update', this.field.name, this.value)
        this.cancel()
      }).catch(error => {
        this.error = error.message
      })
    },
  },
}
</script>
